<template>
  <div id="insideRecommend">
    <div class="medal" v-loading="loading">
      <div class="banner_img">
        <img src="../../assets/medal/banner_img.png" alt="" />
      </div>
      <van-tabs v-model="active" @change="tabChange">
        <van-tab
          :title="item.name"
          :name="item.key"
          v-for="item in tabList"
          :key="item.name"
        ></van-tab>
      </van-tabs>
      <div class="info_list">
        <div class="info_item" v-for="(info, i) in infoItemData" :key="i">
          <div class="item_title">{{ info.title }}</div>
          <div class="item_img_detail">
            <div class="item_img">
              <img :src="'/hrApi' + info.picFilePath" alt="" />
            </div>
            <div class="item_detail">
              <div
                class="detail_tag detail_tag_unpublished"
                v-if="info.taskStatus == 0"
              >
                未发布
              </div>
              <div
                class="detail_tag detail_tag_published"
                v-if="info.taskStatus == 1"
              >
                已发布
              </div>
              <div
                class="detail_tag detail_tag_expire"
                v-if="info.taskStatus == 2"
              >
                已过期
              </div>
              <div
                class="detail_tag detail_tag_expire"
                v-if="info.taskStatus == 3"
              >
                已拒绝
              </div>
              <div class="detail_name">发起部门：{{ info.departmentName }}</div>
              <!-- <div class="detail_name">发起人：{{ info.publishNickname }}</div> -->
            </div>
          </div>
          <div class="item_time">
            评审时效：{{ info.reviewStartTime + " - " + info.reviewEndTime }}
          </div>
          <!-- 未发布 -->
          <div class="item_btn" v-if="info.taskStatus == 0">
            <el-button @click="editInfoM(info)">编辑任务</el-button>
            <!-- <el-button
              type="primary"
              @click="releaseInfoM(info)"
              v-if="isHR == 1"
              >发布</el-button
            > -->
            <el-button
              type="primary"
              @click="reportInfoM(info)"
              v-if="isHR !== 1"
              >新增填报</el-button
            >
          </div>
          <!-- 已发布 -->
          <!-- hr -->
          <div class="item_btn" v-if="info.taskStatus == 1 && isHR == 1">
            <el-button @click="reportInfoM(info)">新增填报</el-button>
            <el-button @click="editInfoM(info)">编辑任务</el-button>
            <el-button type="danger" @click="releaseInfoM(info)"
              >取消</el-button
            >
          </div>
          <!-- 填报 -->
          <div class="item_btn" v-if="info.taskStatus == 1 && isHR == 0">
            <el-button type="primary" @click="reportInfoM(info)"
              >新增填报</el-button
            >
          </div>
          <!-- 已拒绝 -->
          <div class="item_btn" v-if="info.taskStatus == 3">
            <el-button @click="editInfoM(info)">重新提交</el-button>
            <!-- <el-button type="danger" @click="reportDelete(info)"
              >删除</el-button
            > -->
          </div>
        </div>
      </div>
    </div>
    <div class="btn_container" :class="isHR ? '' : 'btn_hr'">
      <el-button type="info" @click="historyReport">
        <img src="../../assets/medal/history_icon.png" alt="" /> 历史填报
      </el-button>
      <el-button type="primary" @click="newRelease" v-if="isHR">
        <img src="../../assets/medal/release_icon.png" alt="" /> 发布任务
      </el-button>
    </div>
  </div>
</template>

<script>
import api from "@/apis/inside";
export default {
  components: {},
  data() {
    return {
      loading: false,
      salaryInfo: {},
      isHR: null,
      tabList: [],
      active: "null",
      infoItemData: [],
      username: {}
    };
  },
  mounted() {
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));

    // 清空 sessionStorage 数据
    sessionStorage.setItem("usernames", "");
    sessionStorage.setItem("nickname", "");
    sessionStorage.setItem("inputValue", "");
    sessionStorage.setItem("changeInfoDepament", "");
    sessionStorage.setItem("datePickerValueStart", "");
    sessionStorage.setItem("datePickerValueEnd", "");
    sessionStorage.setItem("info", JSON.stringify({}));
    sessionStorage.setItem("radio", 0);
    this.initUserInfo();
    this.initPageData("null");
  },
  methods: {
    //获取用户信息
    initUserInfo() {
      api
        .queryByUsername({
          username: this.salaryInfo.empNo
        })
        .then(res => {
          console.log("hahahhahaha");
          if (res.code == 200) {
            this.isHR = res.data.hr;
            console.log(res.data, "res.data");
            this.username = res.data;
            if (this.isHR == 1) {
              // this.tabList = ['全部', '已发布', '未发布', '已到期']
              this.tabList = [
                {
                  key: "null",
                  name: "全部"
                },
                {
                  key: 1,
                  name: "已发布"
                },
                {
                  key: 0,
                  name: "未发布"
                },
                {
                  key: 2,
                  name: "已到期"
                },
                // {
                //   key: 3,
                //   name: "已拒绝"
                // }
              ];
            } else {
              // this.tabList = ['全部', '发布中', '已结束']
              this.tabList = [
                {
                  key: "null",
                  name: "全部"
                },
                {
                  key: 1,
                  name: "发布中"
                },
                {
                  key: 2,
                  name: "已结束"
                },
                // {
                //   key: 3,
                //   name: "已拒绝"
                // }
              ];
            }
          }
        });
    },
    //获取列表数据
    initPageData(val) {
      this.loading = true;
      api
        .queryTaskPageList({
          taskStatus: val
        })
        .then(res => {
          this.loading = false;
          if (res.code == 200) {
            console.log("res.data", res.data);
            this.infoItemData = res.data;
          }
        });
    },
    //tab切换
    tabChange(val) {
      this.active = val;
      this.initPageData(val);
    },
    //新增填报
    reportInfoM(info) {
      console.log(info,'info');
      let obj = {
        nominee: this.username.nickname,
        nominDept: this.username.userDepartmentId,
        nominDeptStr: this.username.department,
        empNo: this.username.username
      };
      this.$store.commit("changeInfoMedal", obj);
      this.$router.push({
        path: "/mobile/medal/taskDetail",
        query: {
          id: info.id,
          isHR: this.isHR
        }
      });
    },
    //编辑任务
    editInfoM(info) {
      this.$router.push({
        path: "/mobile/medal/publishTask",
        query: {
          info: JSON.stringify(info)
        }
      });
    },
    //删除
    reportDelete(info) {
      console.log(info);
      this.$dialog
        .confirm({
          message: "您确定要删除该信息吗？"
        })
        .then(() => {
          api.deleteTask(info.id).then(res => {
            console.log(res);
            if (res.code === 200) {
              this.initPageData(this.active);
              this.$toast("删除成功");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    //取消发布
    releaseInfoM(info) {
      api
        .publishCancel({
          taskId: info.id,
          taskStatus: info.taskStatus
        })
        .then(res => {
          if (res.code == 200) {
            this.initPageData(this.active);
          }
        });
    },
    //历史填报
    historyReport() {
      this.$router.push({
        path: "/mobile/medal/infoDetail",
        query: {
          isHR: this.isHR
        }
      });
    },
    //发布任务
    newRelease() {
      this.$router.push({
        path: "/mobile/medal/publishTask"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #insideRecommend {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #insideRecommend {
    width: 276px * $zoom;
  }
}
#insideRecommend {
  font-size: 16px * $zoom;
  position: relative;
  .medal {
    width: 100%;
    min-height: 100vh;
    background: #f7f9fa;
    padding: 32px;
    .banner_img {
      width: 100%;
      height: 264px;
      background: #ccc;
      margin-bottom: 20px;
      box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info_list {
      height: calc(100vh - 550px);
      margin-top: 20px;
      overflow-y: scroll;
      /* 隐藏滚动条 */
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .info_item {
        width: 100%;
        // height: 498px;
        margin-top: 24px;
        padding: 30px;
        background: #ffffff;
        border-radius: 12px;
        .item_title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 600px;
          font-size: 32px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #282b32;
          line-height: 44px;
        }
        .item_img_detail {
          display: flex;
          .item_img {
            width: 164px;
            height: 172px;
            margin: 24px 20px 24px 0;
            background: #f7f9fa;
            border-radius: 8px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .item_detail {
            .detail_tag {
              width: 100px;
              height: 46px;
              margin: 48px 0 20px;
              border-radius: 8px;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #ffffff;
              line-height: 46px;
              text-align: center;
            }
            .detail_tag_unpublished {
              background: #ff973d;
            }
            .detail_tag_published {
              background: #66bb69;
            }
            .detail_tag_expire {
              background: #b5b5b5;
            }
            .detail_name {
              font-size: 30px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #282b32;
              line-height: 42px;
            }
          }
        }
        .item_time {
          padding-bottom: 30px;
          border-bottom: 2px solid #f1f1f1;
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #282b32;
          line-height: 42px;
        }
        .item_btn {
          display: flex;
          justify-content: flex-end;
          margin-top: 38px;
          .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            // width: 124px;
            height: 52px;
            padding: 0 10px;
            margin-left: 30px;
            border-radius: 8px;
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            &:first-child {
              margin-left: 0;
            }
          }
          .el-button--default {
            background: #ffffff;
            border: 2px solid #5dd5c9;
            color: #5dd5c9;
          }
          .el-button--primary {
            background: #4ea27c;
            border: 2px solid #4ea27c;
          }
          .el-button--danger {
            background: #e65858;
            border: 2px solid #e65858;
          }
        }
      }
    }
  }
  .btn_container {
    position: absolute;
    bottom: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 110px;
    background: #fff;
    .el-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 320px;
      height: 92px;
      line-height: 92px;
      border: none;
      font-size: 32px;
      color: #ffffff;
      border-radius: 16px;
      img {
        width: 36px;
        height: 36px;
        margin-top: -5px;
        vertical-align: middle;
      }
    }
    .el-button--info {
      background: #f3f3f3;
      color: #282b32;
    }
    .el-button--primary {
      background: #4ea27c;
    }
  }
  .btn_hr {
    .el-button {
      width: 90%;
    }
  }
}
::v-deep .van-tabs__nav {
  background: transparent;
  // display: block;
  .van-tab {
    // float: left;
    // width: 120px;
    font-size: 32px;
    line-height: 66px;
    color: #969b9e;
  }
  .van-tab--active {
    font-weight: 800;
    color: #282b32;
  }
  .van-tabs__line {
    width: 48px;
    height: 8px;
    background: #4ea27c;
  }
}
</style>
